import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import iconone from '../../assets/images/img-3928.jpeg';
import icontwo from '../../assets/images/img-3827.jpeg';

export { button, buttonWhite } from '../../styles/components/buttons.style';

export const introTextSection = css`
  padding: 60px 0 60px 20px;

  @media (min-width: ${breakpoints.lg.up}) {
    background: url(${iconone}) no-repeat 0 80px,
      url(${icontwo}) no-repeat 100% 65%;
    padding: 100px 0 100px 20px;
  }
`;

export const introImg = css`
  display: block;
  width: 100%;
  border-radius: 10px;

  @media (max-width: ${breakpoints.md.down}) {
    height: auto; /* Allow the height to adjust based on the image's aspect ratio */
    max-height: 210px; /* Optional: Limit the maximum height */
    object-fit: cover;
  }

  @media (max-width: ${breakpoints.sm.down}) {
    width: 100%; /* Ensure it fits smaller screens */
    height: auto; /* Maintain aspect ratio */
    border-radius: 5px; /* Adjust border radius for smaller screens */
  }
`;

export const headline = css`
  color: ${appColors.gray800};
  font-family: ${fontFamily.fredoka};
  font-size: 28px;
  margin: 0 0 18px;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 46px;
    margin: 0 0 28px;
  }
`;

export const line = css`
  font-size: 18px;
  margin: 0 0 1.25em;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 20px;
  }

  @media (max-width: ${breakpoints.md.down}) {
    br {
      display: none;
    }
  }
`;

export const signupsection = css`
  display: flex;
  background-color: ${appColors.orange};
  border-radius: 10px;
  margin-bottom: 60px;
  padding: 20px;
  img{
    height: auto;
    width: 200px;
  }

  @media (min-width: ${breakpoints.lg.up}) {
    margin-top: 218px;
    padding: 0;
  }
`;

export const signuptitle = css`
  color: ${appColors.white};
  text-align: center;
  font-size: 26px;
  font-family: ${fontFamily.fredoka};
  margin: 0;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 36px;
    margin: 0 0 35px;
  }
`;

export const signupinner = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  align-self: center;
`;

export const signupimg = css`
  flex-shrink: 0;
  display: block;
  max-width: 100%;
  margin-top: -120px;
  height : auto

  &.last {
    margin-right: -25px;
  }

  @media (max-width: ${breakpoints.lg.down}) {
    display: none;
  }
`;
